import { Component } from 'preact';
import AvatarCrownBadge from './AvatarCrownBadge';
import { getCrownsForUser } from '../utils/arena/hallOfFameCache';
import { buildPlayerBadges, resolvePinnedBadges } from '../utils/arena/playerBadges';

// The badges a player pinned to their profile, rendered as a compact
// inline strip for list surfaces (leaderboard rows).
//
// Crowns resolve asynchronously against the shared Hall of Fame cache.
// the same source PlayerTitle uses. So a caller only needs the player
// row it already has (`id`, `isFounder`, `isQaTester`, `pinnedBadgeIds`)
// and doesn't have to plumb a snapshot through. Renders nothing until
// the crowns land, and nothing at all for players with no badges.
export default class PlayerBadgeStrip extends Component {
  state = { badges: [] };

  componentDidMount() {
    this.resolve();
  }

  componentDidUpdate(prevProps) {
    const prev = prevProps.player;
    const next = this.props.player;
    if (
      prev?.id !== next?.id
      || prev?.pinnedBadgeIds !== next?.pinnedBadgeIds
      || prevProps.sorceryCards !== this.props.sorceryCards
    ) {
      this.resolve();
    }
  }

  componentWillUnmount() {
    this._unmounted = true;
  }

  async resolve() {
    const { player, sorceryCards } = this.props;
    if (!player?.id) {
      this.setState({ badges: [] });
      return;
    }
    try {
      const crowns = await getCrownsForUser(player.id, sorceryCards);
      // A virtualized row can be recycled onto a different player while
      // the first fetch is in flight. Drop the stale result.
      if (this._unmounted || this.props.player?.id !== player.id) return;
      const allBadges = buildPlayerBadges({
        crowns,
        isFounder: player.isFounder,
        isQaTester: player.isQaTester,
      });
      this.setState({ badges: resolvePinnedBadges(allBadges, player.pinnedBadgeIds) });
    } catch (err) {
      console.warn('[PlayerBadgeStrip] Failed to resolve badges:', err);
    }
  }

  render() {
    const { size = '1.5cqw', className } = this.props;
    const { badges } = this.state;
    if (!badges.length) return null;
    return (
      <span className={`flex items-end gap-1 shrink-0 ${className || ''}`}>
        {badges.map((badge) => (
          <AvatarCrownBadge key={badge.id} crown={badge} size={size} />
        ))}
      </span>
    );
  }
}
